import api from "../index";

export const GetPromotionKitApi = (params) => api.get(`promotionkit/get-all-promotionkit?${params}`);
export const AddUpdatePromotionKitApi = (data, headers) => api.post('promotionkit/add-update-promotionkit', data, headers);
export const PromotionKitStatusChangeApi = (data) => api.patch(`promotionkit/update-status-promotionkit`, data);
export const DeleteKitsApi = (kitsId) => api.delete(`promotionkit/delete-promotionkit/${kitsId}`);
